import { useEffect, useState } from "react";
import DataTable, { IColumn } from "../../../components/table/data/DataTable";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import taskService from "../../../services/task/TaskService";
import ITask, { ETaskType } from "../../../models/task";
import Toolbar from "../../../components/toolbar/Toolbar";
import DownloadTable from "../../../utils/download/downloadDataTable";
import { IFilter } from "../../../components/table/data/filter/DataFilter";
import { useTranslatedTaskName } from "../../../utils/taskNameTranslation";

const useTaskColumns = () => {
    const { t } = useTranslation();
    const translateTaskName = useTranslatedTaskName();

    const columns: IColumn<ITask>[] = [
        {
            field: "name",
            headerName: t("table.task.taskName"),
            transform: {
                render: (data) => (
                    <Typography variant="body2">{translateTaskName(data)}</Typography>
                ),
                filterTransform: (data) => translateTaskName(data),
            },
        },
        {
            field: "description",
            headerName: t("table.task.taskDescription"),
        },
        {
            field: "type",
            headerName: t("table.task.type"),
            transform: {
                render: (data) => (
                    <Typography variant="body2">
                        {t(`table.task.taskType.${ETaskType[data.type]}`)}
                    </Typography>
                ),
                filterTransform: (data) => {
                    return t(`table.task.taskType.${ETaskType[data.type]}`);
                },
            },
        },
    ];
    return columns;
};

const TaskPage = () => {
    const columns = useTaskColumns();
    const translateTaskName = useTranslatedTaskName();
    const [isFilterActive, setIsFilterActive] = useState<boolean>(true);
    const [tasks, setTasks] = useState<ITask[]>([]);
    const { t } = useTranslation();

    const sortedTasks = [...tasks].sort((a, b) =>
        translateTaskName(a).localeCompare(translateTaskName(b))
    );

    const [filteredRows, setFilteredRows] = useState(tasks);
    const [selectedFilters, setSelectedFilters] = useState<
        Map<string, IFilter>
    >(new Map());

    const visibleFilters: string[] = [];
    selectedFilters.forEach((filter, field) => {
        if (!filter.isActive || !filter.request) return;
        const column = columns.find((column) => column.field === field);
        visibleFilters.push(`${column?.headerName}: ${t(`periodical:filter.${filter.type}`)} ${filter.request}`);
    });

    const downloadTable = new DownloadTable("task", filteredRows, columns, t("table.task.title"), visibleFilters)

    useEffect(() => {
        taskService.GetTasks().then(setTasks)
    }, []);

    return (
        <Box sx={{ width: "100%", height: "100%" }}>
            <Toolbar
                onFilterClick={() => setIsFilterActive((old) => !old)}
                isFilterActive={isFilterActive}
                downloadButtons={[
                    { label: "Excel", onClick: () => downloadTable.GetExcel(t("header.exportedBy"), t("header.exportDate")) },
                    { label: "CSV", onClick: () => downloadTable.GetCSV() },
                    { label: "PDF", onClick: () => downloadTable.GetPDF(t("header.exportedBy"), t("header.exportDate")) }
                ]}
            />

            <DataTable
                dense
                disableFiltrer={!isFilterActive}
                rows={sortedTasks}
                columns={columns}
                onSetFilter={(filteredRows, selectedFilters) => {
                    setFilteredRows(filteredRows)
                    setSelectedFilters(selectedFilters)
                }}
            />
        </Box >
    );
};
export default TaskPage;
